<template>
  <!--begin::General Widget 1-->
  <v-container class="mb-10">
    <div class="">
      <div class="card-header border-0">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label page-title fw-bolder fs-3 mb-1"
            >Manage Expiration Configuration</span
          >
        </h3>
      </div>
    </div>

    <div class="spacer-y-10"></div>

    <div class="card">
      <div class="card-body py-10">
        <div class="tab-content">
          <!--begin::Tap pane-->
          <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">
            <div class="row">
              <div class="col-sm-6">
                <div class="fv-plugins-icon-container">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-5 fw-bold">
                    <span class="required">Barrel Time Limit (days)</span>
                    <i
                      class="fas fa-exclamation-circle ms-2 fs-7"
                      data-bs-toggle="tooltip"
                      v-b-tooltip.hover
                      :title="expirationConfig.expirationNumber.description"
                    ></i>
                  </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input
                    type="number"
                    class="form-control form-control-lg form-control-solid"
                    v-model.number="expirationConfig.expirationNumber.days"
                  />
                  <!--end::Input-->
                  <div class="fv-plugins-message-container invalid-feedback"></div>
                  <div class="d-flex justify-content-center">

                  <button
                    @click="updateExpirationTimeLimit"
                    class="btn fw-bold px-6 py-5 w-10 mb-4 mt-6 btn-primary"
                  >
                    Save
                  </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="fv-plugins-icon-container">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-5 fw-bold">
                    <span class="required">Alert Customers x Days Before Limit</span>
                    <i
                      class="fas fa-exclamation-circle ms-2 fs-7"
                      data-bs-toggle="tooltip"
                      v-b-tooltip.hover
                      :title="expirationConfig.expiringNumber.description"
                    ></i>
                  </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input
                    type="number"
                    class="form-control form-control-lg form-control-solid"
                    v-model.number="expirationConfig.expiringNumber.days"
                  />
                  <!--end::Input-->
                  <div class="fv-plugins-message-container invalid-feedback"></div>
                  <div class="d-flex justify-content-center">
                  <button
                    @click="updateExpirationWarningTime"
                    class="btn fw-bold px-6 py-5 w-10 mb-4 mt-6 btn-primary"
                  >
                    Save
                  </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConfirmationModal
          :isLoadingConfirmation="loadingConfirmation"
          :isShowDialog="isShowConfirmationModal"
          :btnConfig="buttonConfiguration"
          :inputInfo="confirmationModalInfo"
          :inputColor="confirmationModalInfoColor"
          @eConfirm="updateConfig"
          @eCancel="resetUpdateConfig"
        />
        <SnackbarNotifier
          :isShow="isShowSnackBar"
          :message="responseMessage"
          :snackType="snackbarType"
          :colour="snackBarColour"
          @eReset="resetSnackBar"
        />
      </div>
      <!--end::Body-->
    </div>
  </v-container>
  <!--end::General Widget 1-->
</template>
<script>
import { ApiService, ExpirationSK } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "ManageBarrelExpiration",
  data() {
    return {
      loadingConfig: false,
      selectedConfigSk: "",
      newValue: 0,
      expirationConfig: {
        expirationNumber: {
          days: 0,
          description: ""
        },
        expiringNumber: {
          days: 0,
          description: ""
        }
      }
    };
  },
  components: {
    ConfirmationModal,
    SnackbarNotifier,
  },
  methods: {
    updateExpirationTimeLimit(){
      const days = parseInt(this.expirationConfig.expirationNumber.days);
      this.updateExpirationConfirmation(ExpirationSK.ExpirationNumber, days, `Are you sure you want to change the barrel time limit to ${days} days?`);
    },
    updateExpirationWarningTime(){
      const days = parseInt(this.expirationConfig.expiringNumber.days);
      this.updateExpirationConfirmation(ExpirationSK.ExpiringNumber, days, `Are you sure you want to change the expiration warning time to ${days} days before the limit?`);
    },
    updateExpirationConfirmation(sk, days, message){
      this.selectedConfigSk = sk;
      this.newValue = days;
      this.showConfirmationModal({
        title: "Update Expiration Config",
        message,
      });
    },
    resetUpdateConfig(){
      this.isShowConfirmationModal = false;
      this.selectedConfigSk = "";
      this.newValue = 0;
    },
    async updateConfig() {
      try {
        this.startConfirmationLoading();

        await ApiService.Instance.updateBarrelExpirationConfig({sk: this.selectedConfigSk, days: this.newValue});

          this.showNotifier({
            message: `Successfully Updated Configuration`,
            snackbarType: "success",
          });
        this.stopConfirmationLoading();
      } catch (e) {
        this.showNotifier({
          message: `Failed To Update Configuration`,
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        error(e);
      }
      this.resetUpdateConfig();
    },
    async getBarrelExpirationConfig() {
      try {
        this.loadingConfig = true;
        this.expirationConfig = await ApiService.Instance.getBarrelExpirationConfig();
        this.loadingConfig = false;
      } catch (e) {
        this.loadingConfig = false;
        error(e);
      }
    },
  },
  async beforeMount() {
    try {
      await this.getBarrelExpirationConfig();
    } catch (e) {
      error(e);
    }
  },
});
</script>
